module.exports = __webpack_public_path__ + "static/BabyGrad-cb46e92b8130fb1562489dd09c61ee77.png";